const index = {
	namespaced: true,
	state: () => ({
		msdsObject: null,
	}),
	getters: {},
	mutations: {
		setMsdsObject(state, payload) {
			state.msdsObject = { ...payload }
		},
	},
	actions: {},
}
export default index
